import {NgModule} from "@angular/core";
import {RouterModule} from "@angular/router";
import {BootstrapModalModule} from "../ng2-bootstrap-modal/bootstrap-modal.module";

@NgModule({
  imports: [BootstrapModalModule.forRoot({
    container: document.body
  })],
  exports: [RouterModule]
})
export class DashboardBootstrapModalModule {}
